import { makeStyles } from '@material-ui/styles';
import { gainsboro } from '../../../constants/Colors';

export default makeStyles(() => ({
    root: {},
    optionContent: {
        display: 'flex',
    },
    optionLabel: {
        width: '100%',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    deleteIcon: {},
    dividerLabel: {
        width: '100%',
        borderTop: `1px solid ${gainsboro}`,
        padding: '5px 0',
        boxSizing: 'border-box',
        fontSize: '13px',
    },
}));
